// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".superbanner[data-v-68ee5166]{height:90px;position:absolute;right:30px;top:30px;width:728px;z-index:950}@media screen and (max-width:1024px){.superbanner[data-v-68ee5166]{display:none}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
